<template>
    <div id="pcm-project-view">
        <div class="container-fluid">
            <!-- Page Heading -->
            <div class="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="h3 mb-0 text-gray-800">Dự án (đang phát triển)</h1>
            </div>
            <!-- Content Row -->
            <div class="row">
                <div class="col-xl-12">
                    <div class="card mb-4 border-left-primary">
                        <div class="card-body">
                            <el-tabs v-model="activeName" @tab-click="tabClick" >
                                <el-tab-pane name="myProject" label="Dự án">
                                </el-tab-pane>
                                <el-tab-pane name="issues" label="Vấn đề">
                                </el-tab-pane>
                                <el-tab-pane name="overtime" label="Overtime">
                                </el-tab-pane>
                            </el-tabs>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
    

</template>

<script>
import _ from 'lodash'
import Avatar from 'vue-avatar'
import moment from 'moment'


export default {
    name: 'pcm-project-view',
    data() {
        return {
           activeName: 'myProject'
        }
    },
    created() {
        let self = this;
        this.$emit('activeMenu', 'project.index');
        self.tabClick()
    },
    methods: {
      tabClick(tab, event) {
        let self = this
        self.$router.push({name: self.activeName }) 
        self.activeName = self.$router.name
      }
    }
}
</script>

